



























































































import axios from 'axios';
import Vue from 'vue';
import Autocomplete from '@trevoreyre/autocomplete-vue';

export default Vue.extend({
  name: 'Search',
  components: {
    Autocomplete
  },
  data() {
    return {
      minSearchLength: 2,
      focused: false,
      value: '',
      results: [] as string[],
      sfToken: ''
    };
  },
  computed: {
    noResults(): boolean | '' {
      return (
        this.value.length >= this.minSearchLength && this.results.length === 0
      );
    }
  },
  methods: {
    async search(input: string) {
      this.value = input;
      if (input.length < this.minSearchLength) {
        this.results = [];
      } else {
        const { data } = await axios.get(
          `https://functions.solvas.be/api/verzekeringsbewijzen-lookup?code=VsfiRiyxqs_ob7q8Op7GuRKsWijoTRg9me7sNUTS_eAaAzFuWpCKMw==&index=solvas&licensePlate=${input}`
        );
        this.results = data;
      }

      return this.results;
    },
    getResultValue(result: { vehicle: { licensePlate: string } }) {
      return result.vehicle.licensePlate;
    },
    handleFocus() {
      this.focused = true;
    },
    handleBlur() {
      this.focused = false;
    }
  }
});
